<template lang="pug">
div
	page-header(:title='title', :url='url', :titleNew='titleNew')
	vue-element-loading(:active='isActive' spinner='bar-fade-scale' color='#428BCA')
	grid(
		ref="grid" 
		:url='urlDataSource'
		:columns='columns'
		:GridHeight="400"
		:GridPageable="true"
		:DSpageSize="8"
		:DSserverPaging="true"
		:DSschema="true"
		:DSschemaData="'data'"
		:DSschemaTotal="'total'"
		:DSschemaParse="parse"
		:GridPageablePageSizes="[1, 10, 20, 100]"
	)
</template>
	
<script>
import VueElementLoading from 'vue-element-loading'
import PageHeader from '@/components/PageHeader'
import Grid from '@/components/Grid'

import GridTemplate from '@/mixins/GridTemplate'
import TemplateImages from './TemplateImages'
import Permission from '@/mixins/Permission'

import { confirme, erro, sucesso } from '@/components/Message'
import req from '@/components/request'
	
import moment from 'moment'

export default {
	mixins: [GridTemplate, Permission],
	components: {
		VueElementLoading,
		PageHeader,
		Grid
	},
	data() {
		return {
			title: 'Publicidades',
			titleNew: '',
			url: '/sistema/publicidades/',
			urlDataSource: `${this.$url}/publicidades?all=1&status=1&offset=8`,
			columns: [{
				template: this.getTemplateImages,
				title: 'Images',
				width: 40,
			}, {
				field: 'duracao',
				title: 'Duração',
				width: 50
			}, {
				field: 'date_initial',
				title: 'Inicio',
				width: 50
			}, {
				field: 'date_final',
				title: 'Fim',
				width: 50
			},{
				field: 'title',
				title: 'Título',
				width: 400
			}, {
				field: 'active_name',
				title: 'Ativo',
				width: 120
			}],
			isActive: false,
		}
	},
	methods: {
		verifPermissao() {
			this.titleNew = this.ACTION.c ? 'Novo' : ''
			if (this.ACTION.e || this.ACTION.d) {
				this.columns.push({
					field: 'ativo',
					title: 'Ações',
					width: 105,
					template: this.commandTemplate
				})
			}
		},
		parse(d) {
			// Aqui estamos adicionando a chave 'duracao' ao banner, se não houver, atribuímos 10 segundos como padrão
			d.data.map(i => {
				i.date_initial = moment(i.date_initial).format('DD/MM/YYYY')
				i.date_final = moment(i.date_final).format('DD/MM/YYYY')
				// Se a chave 'duracao' não estiver presente, atribuímos o valor 10
				i.duracao = i.duracao || 10 // duração padrão de 10 segundos
				return i
			})
			return d
		},
		getTemplateImages(e) {
			return {
				template: TemplateImages,
				templateArgs: {
					data: e
				}
			}
		},
		async buttonClickApagar(item) {
			const result = await confirme(item.title,'Tem certeza que deseja remover esse registro? pois a exclusão é irreversível e não é possível voltar os dados')
			if(result.isConfirmed) {
				this.isActive = true
				await req(`/publicidades/${item.id}`, 'delete').catch(() => {
					erro()
				})
				sucesso('Atualizado...')
				this.$refs.grid.$refs.datasource1.kendoDataSource.read()
			}
			this.isActive = false
		}
	},
	created() {
		this.verifPermissao()
	}
}
</script>

<style lang="stylus" scoped>

</style>